import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    loading: false,
    loaded: false,
    error: null,
    /** 'teacher' | 'student' — lo decide el servidor según la membresía del curso. */
    role: null,
    tasks: [],
    totalStudents: 0,
    serverNow: null,
};

const tasksSlice = createSlice({
    name: 'tasks',
    initialState,
    reducers: {
        setTasksLoading: (state, { payload }) => {
            state.loading = payload;
            if (payload) state.error = null;
        },
        setTasksData: (state, { payload }) => {
            state.loading = false;
            state.loaded = true;
            state.error = null;
            state.role = payload.role;
            state.tasks = (payload.tasks || [])
                .slice()
                .sort((a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0));
            state.totalStudents = payload.totalStudents || 0;
            state.serverNow = payload.serverNow || null;
        },
        setTasksError: (state, { payload }) => {
            state.loading = false;
            state.error = payload;
        },
        upsertTask: (state, { payload }) => {
            const index = state.tasks.findIndex((t) => t._id === payload._id);
            if (index === -1) {
                state.tasks.unshift(payload);
            } else {
                state.tasks[index] = { ...state.tasks[index], ...payload };
            }
            state.tasks.sort((a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0));
        },
        applyTaskSubmission: (state, { payload }) => {
            const task = state.tasks.find((t) => t._id === payload.taskId);
            if (task) {
                task.mySubmission = payload.submission;
                task.canSubmit = false;
            }
        },
        /** Entrega remota: el profesor ve el conteo subir sin refetch completo. */
        applyRemoteSubmission: (state, { payload }) => {
            const task = state.tasks.find((t) => String(t._id) === String(payload.taskId));
            if (task && typeof payload.submittedCount === 'number') {
                task.submittedCount = payload.submittedCount;
            }
        },
        applyTaskGrade: (state, { payload }) => {
            const task = state.tasks.find((t) => String(t._id) === String(payload.taskId));
            if (!task) return;
            if (task.mySubmission) {
                task.mySubmission = { ...task.mySubmission, ...payload.submission };
            }
            if (typeof payload.gradedCount === 'number') {
                task.gradedCount = payload.gradedCount;
            }
        },
        resetTasks: () => initialState,
    },
});

export const {
    setTasksLoading,
    setTasksData,
    setTasksError,
    upsertTask,
    applyTaskSubmission,
    applyRemoteSubmission,
    applyTaskGrade,
    resetTasks,
} = tasksSlice.actions;

export default tasksSlice.reducer;
